import {
  DefaultInfoContainer,
  flattenErrorTypeArray,
  ValidIcon,
  SVGInfo,
} from '@equifinance/shared';
import styled, { css } from 'styled-components';
import {

  useCreditContext,
  creditAddressSort,
} from '../../contexts/credit';
import Section from '../Account/components/Section';
import { SectionTitleIcon } from '../Account/Icons/SectionTitleIcon';
import InsolvencyTable from './InsolvencyTable';

const InfoContainer = styled(DefaultInfoContainer)` ${({ theme }) => `
  margin:${theme.padding[4]};
  margin-bottom:0;
  max-width: 100%;
  width: auto;
`}`;

const ErrorContainerCss = css`${({ theme }) => `
  padding: 0 ${theme.padding[4]};
`}`;

export default function InsolvencyTables() {
  const {
    credit,
    insolvencyAddresses,
    expandedStates,
    handleToggle,
  } = useCreditContext();

  const { errors, warnings } = credit;

  const { insolvencyRecords, id } = credit.insolvencyRecords;

  const insolvencyRecordErrors = Object.keys(insolvencyRecords ?? {}).map((id) => errors?.[id] ?? []).flat();
  const combinedErrors = flattenErrorTypeArray([
    ...(errors?.[id] ?? []),
    ...insolvencyRecordErrors,
  ]);

  const refName = 'insolvency-credit-table';

  return (
    <Section
      id={credit?.insolvencyRecords?.id}
      refName={refName}
      title="Court and Insolvency Information"
      titleIcon={(
        <SectionTitleIcon
          errors={combinedErrors}
          tickIcon={<ValidIcon inverted />}
        />
      )}
      errorContainerCss={ErrorContainerCss}
      errors={errors}
      warnings={warnings}
      collapsed={!expandedStates[refName]}
      onClickCollapse={() => handleToggle(refName)}
    >
      <InfoContainer>
        <SVGInfo>Please ensure that all currently unsatisfied insolvencies and those satisfied in the last 24 months are added to the table below.</SVGInfo>
      </InfoContainer>

      {Object.values(insolvencyAddresses).sort(creditAddressSort).map((address) => (
        <InsolvencyTable address={address} key={address?.id} />
      ))}
    </Section>
  );
}
